module.exports = __webpack_public_path__ + "static/media/linkedin-icon-1.bf7d1283.svg";